import React from "react"

export const SectionHeader = props => {
  return (
    <div className='font-semibold text-2xl sm:text-2xl md:text-3xl text-primary'>
      {props.children}
    </div>
  )
}
